import script from "./ResponsibleStay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResponsibleStay.vue?vue&type=script&setup=true&lang=ts"

import "./ResponsibleStay.vue?vue&type=style&index=0&id=f590681a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f590681a"]])

export default __exports__